import { ReactNode } from "react";

interface ColoredProductCardProps {
  bgColor?: string;
  children: ReactNode;
}

export function ColoredProductCard({ bgColor, children }: ColoredProductCardProps) {
  const bgColorWithOpacity = bgColor ? `${bgColor}15` : 'transparent';

  return (
    <div 
      className="flex justify-between items-start py-3 px-4 rounded-lg border"
      style={{
        backgroundColor: bgColorWithOpacity,
        borderColor: bgColor
      }}
    >
      {children}
    </div>
  );
}

export function ColoredProductIcon({ bgColor }: { bgColor?: string }) {
  return (
    <div 
      className="w-4 h-4 rounded-sm flex-shrink-0" 
      style={{
        backgroundColor: bgColor,
        border: '1px solid rgba(0,0,0,0.1)'
      }}
    />
  );
} 